export const CHARITY_LIST_PAGINATION_LIMIT = 4;
export const PRODUCT_LIST_PAGINATION_LIMIT = 20;

const PARENT = 'parent';
const PRODUCT = 'product';
const CHARITY = 'charity';
const GIFT_CARD = 'gift-card';

export const PRODUCT_TYPES = {
  PARENT,
  PRODUCT,
  CHARITY,
  GIFT_CARD
};

export const SECONDARY_PRODUCT_TYPES = [CHARITY, GIFT_CARD];
